import React, { useMemo } from 'react';
import useChromeExtension from '~/react-hooks/use-chrome-extension';
import InstallChromeExtension from '~/App/Components/Buttons/InstallChromeExtension';
import EmptyState, {
  EmptyBody,
  EmptyStateLayoutType,
  EmptyStateProps,
  EmptyTitle,
} from './EmptyState';
import { assetUrl } from '~/helpers';
import {
  FilteredTagsProps,
  getTagNames,
} from '../../Tags/Components/TagFilter/hooks/useFilteredTags';

export type EmptyRecordingProps = Pick<
  EmptyStateProps,
  'layout' | 'className'
> &
  FilteredTagsProps;

export default function EmptyRecording({
  layout = EmptyStateLayoutType.full,
  className,
  tags = [],
  clearTags,
}: EmptyRecordingProps) {
  const {
    installed: isChromeExtensionInstalled,
    checking: isChromeExtensionChecking,
  } = useChromeExtension();

  const buttons = useMemo(() => {
    if (isChromeExtensionChecking) {
      return <span className='fa fa-spinner spinning' />;
    }

    const btnClassName = layout === EmptyStateLayoutType.full ? '' : 'w-full';

    return (
      !isChromeExtensionInstalled && (
        <InstallChromeExtension btnClassName={btnClassName} />
      )
    );
  }, [isChromeExtensionInstalled, isChromeExtensionChecking, layout]);

  const handleTagsClearClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    clearTags?.();
  };

  const { title, body } = useMemo(() => {
    const title = (
      <EmptyTitle
        noun='recording'
        tagNames={tags.length > 0 ? getTagNames(tags) : undefined}
      />
    );

    const body = (
      <EmptyBody
        variant={tags.length > 0 ? 'tagged' : 'default'}
        noun='recording'
        layout={layout}
        defaultBody='All your videos recorded with Bonjoro Chrome extension will appear here'
        onYourLibraryClick={handleTagsClearClick}
      />
    );

    return {
      title,
      body,
    };
  }, [tags, layout]);

  return (
    <EmptyState
      layout={layout}
      className={className}
      imageUrl={assetUrl('assets/images/my-library/chrome.png')}
      title={title}
      body={body}
      actions={buttons}
    />
  );
}
